import { combineReducers } from "redux";
import { AuthReducer } from "../Reducer/AuthReducer";
import CountryReducer from "../Reducer/CountryReducer";

const RootReducer = combineReducers({
     countery : CountryReducer,
     auth: AuthReducer
})

export default RootReducer